import React from "react";

//REDUX
import { useSelector } from "react-redux";

//#region CSS
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles(theme => ({
  root: {
    position: "fixed",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: 2050,
    background: "center no-repeat rgba(16, 3, 75, 0.3)"
  },
  spinner: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: "auto"
  }
}));
//#endregion

export default function Loading() {
  const classes = useStyles();

  const loading = useSelector(state => state.loading);
  const loadingEmpresa = useSelector(state => state.empresas.isLoading);
  const loadingCentro = useSelector(state => state.centros.isLoading);
  const loadingZonaCentro = useSelector(state => state.zonasCentro.isLoading);
  const loadingGrupoPartida = useSelector(state => state.grupoPartida.isLoading);
  const loadingModeloMaq = useSelector(state => state.modelosMaquina.isLoading);
  const loadingPerfilUsuario = useSelector(state => state.perfilesUsuario.isLoading);
  const loadingUsuarioCentros = useSelector(state => state.usuarioCentros.isLoading);
  const loadingTipoArticulo = useSelector(state => state.tiposArticulo.isLoading);
  const loadingTiposMaquina = useSelector(state => state.tiposMaquina.isLoading);
  const loadingTiposPartida = useSelector(state => state.tiposPartida.isLoading);
  const loadingTiposZona = useSelector(state => state.tiposZona.isLoading);
  const loadingTiposZonaIva = useSelector(state => state.tipoZonaIva.isLoading);
  const loadingCajasCentro = useSelector(state => state.cajasCentro.isLoading);
  const loadingPromotion = useSelector(state => state.promocion.isLoading);
  const loadingFamilia = useSelector(state => state.familia.isLoading);
  const loadingSubFamilia = useSelector(state => state.subFamilia.isLoading);
  const loadingTipoFicha = useSelector(state => state.tipoFicha.isLoading);
  const loadingTipoFichaSub = useSelector(state => state.tipoFichaSub.isLoading);
  const loadingTipoMovRedem = useSelector(state => state.tipoMovRedem.isLoading);
  const loadingMotivo = useSelector(state => state.motivo.isLoading);
  const loadingMaeMaquina = useSelector(state => state.maeMaquinas.isLoading);


  const displayLoading = loading || loadingEmpresa || loadingCentro || loadingZonaCentro
    || loadingGrupoPartida || loadingModeloMaq || loadingPerfilUsuario || loadingUsuarioCentros
    || loadingTipoArticulo || loadingTiposMaquina || loadingTiposPartida || loadingTiposZona
    || loadingTiposZonaIva || loadingCajasCentro || loadingPromotion || loadingFamilia
    || loadingSubFamilia || loadingTipoFicha || loadingTipoFichaSub || loadingTipoMovRedem
    || loadingMotivo || loadingMaeMaquina
    ? (
      <div className={classes.root}>
        <CircularProgress
          className={classes.spinner}
          color="secondary"
          size={75}
        />
      </div>
    ) : null;

  return <React.Fragment>{displayLoading}</React.Fragment>;
}
